import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import styles from "./heading.module.scss";

const Heading = ({ text, className }) => {
  return <p className={cx(styles.heading, className)}>{text}</p>;
};

Heading.propTypes = {
  text: null,
  className: "",
};

Heading.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};

export default Heading;
